import request from '../services/request';

export function search(data) {
  return request({
    url: `/company/search`,
    method: 'POST',
    data,
  });
}

export function searchCompanies(data, page) {
  return request({
    url: `/company/search?page=${page}`,
    method: 'POST',
    data,
  });
}

export function storeCompany(data) {
  return request({
    url: `/company`,
    method: 'POST',
    data,
  });
}

export function updateCompany(id, data) {
  return request({
    url: `/company/${id}`,
    method: 'PUT',
    data,
  });
}

export function statusCompany(id, data) {
  return request({
    url: `/company/${id}/status`,
    method: 'PUT',
    data,
  });
}

export function getCompanyById(id) {
  return request({
    url: `/company/${id}`,
    method: 'GET',
  });
}

export function getDataBilliong(id) {
  return request({
    url: `/company/${id}/billing-information`,
    method: 'GET',
  });
}

export function exportFile(data, configs) {
  return request({
    url: `/company/export`,
    method: 'POST',
    responseType: 'blob',
    data,
    ...configs,
  });
}

export function catalogVersions() {
  return request({
    url: `/company/catalog/versions`,
    method: 'GET',
  });
}

export function catalogDbConnection() {
  return request({
    url: `/company/catalog/mongodb/connections`,
    method: 'GET',
  });
}
